import {Component} from '@angular/core';
import {RouterLink} from "@angular/router";
import {GuestComponent} from '../../../layout/guest/guest.component';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {PasswordService} from '../../../../services/password-lost/password.service';
import {LoaderService} from '../../../../services/loader/loader.service';
import {MetaTitle} from '../../../../decorator/meta-title';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-password-lost',
  imports: [
    RouterLink,
    GuestComponent,
    ReactiveFormsModule,
    NgIf
  ],
  templateUrl: './password-lost.component.html',
  styleUrl: './password-lost.component.scss'
})
@MetaTitle('Password lost')
export class PasswordLostComponent {
  submitted = false;

  form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });

  constructor(
    private loader: LoaderService,
    private passwordService: PasswordService
  ) {
  }

  onSubmit(): void {
    if (!this.form.valid) {
      return;
    }

    this.loader.startLoading();

    const data: any = this.form.value;

    this.passwordService.passwordLost(data.email).subscribe(() => {
      this.submitted = true;
      this.loader.stopLoading();
    });
  }
}
